import PropTypes from 'prop-types';
import React from 'react';
import AvatarComponent from './Avatar';
import IconComponent from './Icon';
import './Title.css';

const Title = React.memo(({ avatar, icon, title, caption, trivial }) => (
  <section className="title">
    {icon ? (
      <IconComponent src={icon} caption={title} />
    ) : (
      <AvatarComponent image={avatar} name={title} />
    )}
    <hgroup>
      <h1 className={trivial ? 'trivial' : ''}>{title}</h1>
      {caption && <h2>{caption}</h2>}
    </hgroup>
  </section>
));

Title.propTypes = {
  avatar: PropTypes.string,
  icon: PropTypes.string,
  title: PropTypes.string.isRequired,
  caption: PropTypes.string,
  trivial: PropTypes.bool
};

Title.defaultProps = {
  avatar: undefined,
  icon: undefined,
  caption: undefined,
  trivial: false
};

export default Title;
